import { Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShippingConfigType } from '../../../../_models/shipping-config.interface';
import { ShippingTargetDialogState } from '../shipping-target-dialog.state';

/**
 * Seite 1 des Versandziel-Dialogs: Wohin geht das Material? Vier Kacheln mit
 * je einem Satz Erklärung; gesperrte Typen nennen den Grund direkt in der
 * Kachel statt nur im Tooltip.
 *
 * Die Kacheln sind bewusst `div`s (nicht `button`): ein Button legt seinen
 * Inhalt in eine zentrierte Box, die nicht mitwächst — die Karte würde
 * überlaufen. Das Klick-Muster entspricht den Auswahl-Karten der LagerApp.
 */
@Component({
  standalone: true,
  selector: 'hawk-shipping-type-select-page',
  imports: [FontAwesomeModule],
  template: `
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
      @for (type of state.selectableTypes(); track type.value) {
        @let reason = state.typeDisabledReason(type.value);
        @let selected = state.selectedType() === type.value && reason === null;
        <div
          class="bm-card bm-card-sm bm-card-body bm-card-border transition-colors"
          [class.border-primary]="selected"
          [class.border-base-300]="!selected"
          [class.cursor-pointer]="reason === null"
          [class.opacity-50]="reason !== null"
          [class.cursor-not-allowed]="reason !== null"
          [attr.role]="reason === null ? 'button' : null"
          [attr.tabindex]="reason === null ? 0 : null"
          (click)="choose(type.value, reason)"
          (keydown.enter)="choose(type.value, reason)"
        >
          <div class="bm-card-title text-base">
            <fa-icon [icon]="type.icon" />
            <span>{{ type.label }}</span>
          </div>
          <p class="text-xs opacity-70">{{ type.description }}</p>
          @if (reason !== null) {
            <p class="text-xs text-error">{{ reason }}</p>
          }
        </div>
      }
    </div>
  `,
})
export class ShippingTypeSelectPageComponent {
  protected state = inject(ShippingTargetDialogState);

  protected choose(type: ShippingConfigType, reason: string | null): void {
    if (reason !== null) return;
    this.state.setType(type);
  }
}
